/**
 * Utilerías para validación de sesión (basado en expires_in / timestamp)
 * Nota: El token ya no se almacena en el cliente (cookies HttpOnly)
 */

/**
 * Indica si existe token_expires_in en localStorage
 * @returns {boolean} - true si hay timestamp, false si no está presente
 */
export function hasExpirationTimestamp() {
  const expiresIn = localStorage.getItem('token_expires_in')
  return expiresIn != null && expiresIn !== ''
}

/**
 * Verifica si la sesión está expirada basándose en el timestamp guardado
 * @param {object} store - Instancia del store de Vuex
 * @returns {boolean} - true si expiró, false si es válida
 */
export function isCurrentTokenExpired(store) {
  const expiresIn = store.getters['auth/getTokenExpiresIn']

  if (!expiresIn) return true

  const expirationDate = new Date(expiresIn * 1000)
  // Buffer de 10 min: considerar expirado antes del vencimiento real
  const expirationDateWithBuffer = new Date(expirationDate.getTime() - 600000)
  const currentDate = new Date()

  return currentDate > expirationDateWithBuffer
}
